import React from "react";
import { cardVariants, type CardVariants } from "@/utils/variants";
import { cn } from "@/utils";

interface CardProps extends CardVariants {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ padding, rounded, interactive, shadow, children, className, onClick }) => {
  return (
    <div className={cn(cardVariants({ padding, rounded, interactive, shadow }), className)} onClick={onClick}>
      {children}
    </div>
  );
};

export default Card;
